<template>
  <b-container fluid class="p-5">
    <b-row>
      <b-col
        v-for="(option, index) in banks"
        :key="index"
        lg="4"
        md="6"
        v-b-modal.mobile-modal
      >
        <div class="mb-3 bg-grey rounded p-5 text-center">
          <img
            :src="option.logo"
            class="rounded-circle"
            width="90"
            height="90"
          />
          <h5 class="text-secondary my-3">{{ option.name }}</h5>
        </div>
      </b-col>
    </b-row>
    <VDownloadMobile></VDownloadMobile>
    <b-pagination
      v-model="page"
      :current-page="meta.current_page"
      :per-page="meta.per_page"
      :total-rows="meta.last_page * meta.per_page"
    ></b-pagination>
  </b-container>
</template>

<script>
export default {
  data() {
    return {
      page: 1,
    };
  },
  watch: {
    page() {
      this.get();
    },
  },
  mounted() {
    this.get();
  },
  computed: {
    banks() {
      return this.$store.state.website.banks.list;
    },
    meta() {
      return this.$store.state.website.banks.meta;
    },
  },
  methods: {
    get() {
      this.$store.dispatch("website/banks/get", this.page);
    },
  },
};
</script>
<style lang="scss" scoped>
.bg-grey {
  background-color: #edf4fc !important;
}
.col-md-6,
.col-lg-4 {
  transition: 0.3s ease !important;
}
.col-md-6:hover,
.col-lg-4:hover {
  transform: scale(1.1);
}
</style>
